import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CharacterSpeak from './CharacterSpeak';//eslint-disable-line import/no-named-as-default
import LearnerSpeak from './LearnerSpeak';//eslint-disable-line import/no-named-as-default
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default

import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as dataHelper from '../../../helpers/dataHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import {getChildObjectComponentByType} from "../../../helpers/componentHelper";

class ChildConversationDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            initialised: false,
            dialogs: this.props.dialogs,
            renderedDialogs:[],
            callbacks:{},
            delay: 0

        };

        this.onComplete = this.onComplete.bind(this);
        this.setDialog = this.setDialog.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
    }

    componentDidMount() {
        this.setCallbacks();
        this.setDialog(0);
    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate(){
        if(this.state.setVariable){
            this.getVariable();
        }
    }

    setCallbacks(){
        this.setState({
            callbacks: Object.assign({},this.props.callbacks,{
                onObjectComplete: this.onObjectComplete,
                getCharacterName: appHelper.isDefined(this.props.callbacks.getCharacterName) ? this.props.callbacks.getCharacterName :  appHelper.getScreenCharacterNameByAssetId(this.props.asset_id)
            }),
        });
    }


    onObjectComplete(index){
        let nextIndex = index + 1;
        if(nextIndex < this.state.dialogs.length){
            this.setDialog(nextIndex);
        }else{
            this.onComplete();
        }

    }

    setDialog(index){
        let dialog = Object.assign({},this.state.dialogs[index]);
        let dialogType = Object.assign({}, getChildObjectComponentByType(dialog.object_type),
            {
                data: dialog,
                index: index
            }
        );
        this.setState({renderedDialogs: dataHelper.immutablePush(this.state.renderedDialogs,dialogType)});
    }


    onComplete(){
        if(appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete();
        }
    }


    render() {
        return (
            <div className="content-dialogs" ref={this.props.option_id}>
                {this.state.renderedDialogs.map(dialog =>
                    <div key={`diaglog_${dialog.index}`} >
                    <dialog.component asset_id={this.props.asset_id} option_id={this.props.option_id} index={dialog.index} dialog={dialog.data} callbacks={this.state.callbacks} delay={this.state.delay}/>
                    </div>
                )}
            </div>

        );
    }
}

ChildConversationDialog.propTypes = {
    asset_id:PropTypes.number.isRequired,
    option_id:PropTypes.number.isRequired,
    dialogs: PropTypes.array.isRequired,
    callbacks: PropTypes.object.isRequired,
    onComplete:PropTypes.func,
    actions: PropTypes.object
};

ChildConversationDialog.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChildConversationDialog);



/** WEBPACK FOOTER **
 ** ./src/components/objects/conversationDialog/ChildConversationDialog.js
 **/